import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import DivideRefereesContainer from "../../containers/schedule/DivideRefereesContainer";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Icon from "@mdi/react";
import { mdiWhistle } from "@mdi/js";
import RefereeChip from "./RefereeChip";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

class RefereesCard extends Component {
  state = {
    open: false,
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  resetReferees = () => {
    let fieldsForSelectedLocation = Object.keys(
      this.props.tournament.fields || {}
    ).filter((key) => {
      let field = this.props.tournament.fields[key];
      let showField = false;
      if (this.props.selectedSportPark === "0") {
        if (field.sportPark === undefined || field.sportPark === "0") {
          showField = true;
        }
      } else {
        if (field.sportPark === this.props.selectedSportPark) {
          showField = true;
        }
      }
      return showField;
    });
    const db = window.firebase.firestore();
    let batch = db.batch();
    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");
    this.props.matchesWithReferees
      .filter((matchId) => {
        let match = this.props.matchesByKey[matchId] || {};
        return (
          match.day === this.props.selectedDay &&
          fieldsForSelectedLocation.indexOf(match.field) !== -1
        );
      })
      .forEach(function (id) {
        batch.update(matchesRef.doc(id), {
          referee: "",
          referee2: "",
          referee3: "",
          referee4: "",
          referee5: "",
        });
      });

    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }

    batch.commit();
    this.toggleDialog();
  };

  handleNumRefereesChange = (event) => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    tournamentRef.update({ numRefereesPerMatch: event.target.value });
  };

  render() {
    let fieldsForSelectedLocation = Object.keys(
      this.props.tournament.fields || {}
    ).filter((key) => {
      let field = this.props.tournament.fields[key];
      let showField = false;
      if (this.props.selectedSportPark === "0") {
        if (field.sportPark === undefined || field.sportPark === "0") {
          showField = true;
        }
      } else {
        if (field.sportPark === this.props.selectedSportPark) {
          showField = true;
        }
      }
      return showField;
    });

    let matchesWithReferees = this.props.matchesWithReferees.filter(
      (matchId) => {
        let match = this.props.matchesByKey[matchId] || {};
        return (
          match.day === this.props.selectedDay &&
          fieldsForSelectedLocation.indexOf(match.field) !== -1
        );
      }
    );

    return (
      <div
        style={{
          padding: 10,
          overflowY: "auto",
          height: "calc(100vh - 132px)",
        }}
      >
        <Typography variant="h6">
          {this.props.tournament.useJudges
            ? languages.referees.judges
            : languages.schedule.referees}
        </Typography>
        <div style={{ marginTop: 20, padding: "0 2px" }}>
          <FormControl style={{ width: "100%" }}>
            <Select
              fullWidth
              value={this.props.tournament.numRefereesPerMatch || "1"}
              onChange={this.handleNumRefereesChange}
              inputProps={{
                name: "numRefereesPerMatch",
              }}
            >
              <MenuItem value="1">
                {this.props.tournament.useJudges
                  ? languages.referees.oneJudgePerMatch
                  : languages.referees.oneRefereePerMatch}
              </MenuItem>
              <MenuItem value="2">
                {this.props.tournament.useJudges
                  ? languages.referees.twoJudgesPerMatch
                  : languages.referees.twoRefereesPerMatch}
              </MenuItem>
              <MenuItem value="3">
                {this.props.tournament.useJudges
                  ? languages.referees.threeJudgesPerMatch
                  : languages.referees.threeRefereesPerMatch}
              </MenuItem>
              <MenuItem value="4">
                {this.props.tournament.useJudges
                  ? languages.referees.fourJudgesPerMatch
                  : languages.referees.fourRefereesPerMatch}
              </MenuItem>
              <MenuItem value="5">
                {this.props.tournament.useJudges
                  ? languages.referees.fiveJudgesPerMatch
                  : languages.referees.fiveRefereesPerMatch}
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        <Link
          style={{ textDecoration: "none", color: "black" }}
          to={
            "/tournament/" + this.props.tournament[".key"] + "/teams/referees"
          }
        >
          <Button
            variant="outlined"
            size="small"
            fullWidth
            style={{ marginTop: 10 }}
          >
            {this.props.tournament.useJudges
              ? languages.referees.manageJudges
              : languages.referees.manageReferees}
          </Button>
        </Link>

        {matchesWithReferees.length > 0 && (
          <div>
            <Button
              variant="outlined"
              size="small"
              fullWidth
              style={{ marginTop: 10 }}
              onClick={this.toggleDialog}
              disabled={this.props.tournament.scheduleLocked || false}
            >
              {this.props.tournament.useJudges
                ? languages.referees.resetJudges
                : languages.referees.resetReferees}
            </Button>
            <Dialog
              open={this.state.open}
              onClose={this.toggleDialog}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">
                {this.props.tournament.useJudges
                  ? languages.referees.resetJudges
                  : languages.referees.resetReferees}
              </DialogTitle>
              <DialogContent style={{ width: 350, maxWidth: "97%" }}>
                <DialogContentText>
                  {this.props.tournament.useJudges
                    ? languages.referees.resetDescription2
                    : languages.referees.resetDescription}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.toggleDialog} color="primary">
                  {languages.general.cancel}
                </Button>
                <Button
                  onClick={this.resetReferees}
                  variant="contained"
                  color="primary"
                >
                  {languages.general.continue}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}

        {this.props.referees.length > 0 && (
          <DivideRefereesContainer
            tournament={this.props.tournament}
            referees={this.props.referees}
            daysByKey={this.props.daysByKey}
            matches={this.props.matches}
            selectedDay={this.props.selectedDay}
            selectedSportPark={this.props.selectedSportPark}
            poulesByKey={this.props.poulesByKey}
            refereesByKey={this.props.refereesByKey}
            bracketsByKey={this.props.bracketsByKey}
            teams={this.props.teams}
            teamsByKey={this.props.teamsByKey}
            divisionsObject={this.props.divisionsObject}
          />
        )}
        <div
          style={{
            minHeight: 150,
            width: "100%",
            overflowY: "auto",
            marginTop: 15,
            marginBottom: 5,
          }}
        >
          <Droppable droppableId={"refereesBack"} type="REFEREE">
            {(provided, snapshot) => {
              return (
                <div
                  ref={provided.innerRef}
                  style={{
                    minHeight: 145,
                  }}
                >
                  {snapshot.isDraggingOver && (
                    <div
                      style={{
                        position: "absolute",
                        backgroundColor: "white",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 20,
                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          marginTop: 150,
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        {languages.tournament.back}
                      </Typography>
                    </div>
                  )}
                  <Droppable
                    droppableId="referees"
                    type="REFEREE"
                    direction="horizontal"
                    isDropDisabled={true}
                  >
                    {(provided, snapshot) => {
                      return (
                        <div
                          ref={provided.innerRef}
                          style={{
                            minHeight: 133,
                          }}
                        >
                          {this.props.referees.length > 0 ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                flexWrap: "wrap",
                                overflowX: "hidden",
                              }}
                            >
                              {this.props.referees
                                .sort((a, b) => {
                                  function chunkify(t) {
                                    var tz = [],
                                      x = 0,
                                      y = -1,
                                      n = 0,
                                      i,
                                      j;

                                    while (
                                      (i = (j = t.charAt(x++)).charCodeAt(0))
                                    ) {
                                      // eslint-disable-next-line
                                      var m = i == 46 || (i >= 48 && i <= 57);
                                      if (m !== n) {
                                        tz[++y] = "";
                                        n = m;
                                      }
                                      tz[y] += j;
                                    }
                                    return tz;
                                  }

                                  let toChunkA = a["name"] || "";
                                  let toChunkB = b["name"] || "";

                                  var aa = chunkify(
                                    toChunkA.toString().toLowerCase()
                                  );
                                  var bb = chunkify(
                                    toChunkB.toString().toLowerCase()
                                  );

                                  for (let x = 0; aa[x] && bb[x]; x++) {
                                    if (aa[x] !== bb[x]) {
                                      var c = Number(aa[x]),
                                        d = Number(bb[x]);
                                      // eslint-disable-next-line
                                      if (c == aa[x] && d == bb[x]) {
                                        return c - d;
                                      } else return aa[x] > bb[x] ? 1 : -1;
                                    }
                                  }
                                  return aa.length - bb.length;
                                })
                                .map((referee, i) => {
                                  return (
                                    <div
                                      key={referee.id}
                                      style={{ padding: "3px 0" }}
                                    >
                                      <Draggable
                                        draggableId={referee.id}
                                        index={i}
                                        type="REFEREE"
                                        isDragDisabled={
                                          this.props.tournament
                                            .scheduleLocked || false
                                        }
                                      >
                                        {(provided, snapshot) => (
                                          <div>
                                            <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                            >
                                              <RefereeChip
                                                refereeId={referee.id}
                                                referee={referee}
                                                tournament={
                                                  this.props.tournament
                                                }
                                                inSidebar={true}
                                                selectedSportPark={
                                                  this.props.selectedSportPark
                                                }
                                                selectedDay={
                                                  this.props.selectedDay
                                                }
                                                matches={this.props.matches}
                                                teamsByKey={
                                                  this.props.teamsByKey
                                                }
                                              />
                                            </div>
                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Draggable>
                                    </div>
                                  );
                                })}
                            </div>
                          ) : (
                            <div style={{ width: "100%", textAlign: "center" }}>
                              <Icon
                                path={mdiWhistle}
                                size={2}
                                color={"rgba(0, 0, 0, 0.54)"}
                                style={{ marginTop: 20 }}
                              />
                              <Typography>
                                {this.props.tournament.useJudges
                                  ? languages.referees.noJudgesMessage
                                  : languages.referees.noRefereesMessage}
                              </Typography>
                            </div>
                          )}
                          {provided.placeholder}
                        </div>
                      );
                    }}
                  </Droppable>
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </div>
      </div>
    );
  }
}

export default RefereesCard;
